import { render } from "./RecordsTableHeader.vue?vue&type=template&id=1d667964&ts=true"
import script from "./RecordsTableHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecordsTableHeader.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/RecordsTableHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d667964"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d667964', __exports__)) {
    console.log('reload')
    api.reload('1d667964', __exports__)
  }
  
  module.hot.accept("./RecordsTableHeader.vue?vue&type=template&id=1d667964&ts=true", () => {
    console.log('re-render')
    api.rerender('1d667964', render)
  })

}


export default __exports__